import React, {useState, useEffect} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import ButtonBase from '@mui/material/ButtonBase';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ExitIcon from '@mui/icons-material/ExitToApp';
import OfferIcon from '@mui/icons-material/LocalOffer';
import NotifyIcon from '@mui/icons-material/NotificationsActive';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { api } from 'common';
import { colors } from '../components/Theme/WebTheme';
import { useTranslation } from "react-i18next";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MoneyIcon from '@mui/icons-material/Money';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import {calcEst, showEst, optionsRequired} from '../common/sharedFunctions';
import SosIcon from '@mui/icons-material/Sos';
import {MAIN_COLOR, SECONDORY_COLOR} from "../common/sharedFunctions"
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import MapIcon from '@mui/icons-material/Map';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import HubIcon from '@mui/icons-material/Hub';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import logoImg from '../assets/img/logo192x192.png';
import sidebarPromoImg from '../assets/img/driver_vertical.jpg';
import DashboardPageBanner from './DashboardPageBanner';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LocalTaxiOutlinedIcon from '@mui/icons-material/LocalTaxiOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';

const drawerWidth = 260;
const SIDEBAR_BG = '#1A0F3B';
const ACTIVE_BG = '#6411ED';

export default function ResponsiveDrawer(props) {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [desktopOpen, setDesktopOpen] = React.useState(() => {
    try {
      const saved = localStorage.getItem('c2_sidebar_open');
      return saved !== null ? saved === 'true' : true;
    } catch (e) {
      return true;
    }
  });

  const toggleDesktopSidebar = () => {
    setDesktopOpen((prev) => {
      const next = !prev;
      try {
        localStorage.setItem('c2_sidebar_open', String(next));
      } catch (e) {}
      return next;
    });
  };
  const { signOff } = api;
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const location = useLocation();
  const sosList = useSelector(state => state.sosdata.sos);
  const pendingSos = auth?.profile?.usertype === 'admin'
    ? (sosList || []).filter((s) => api.sosStatusOf(s) === 'pending').length
    : 0;
  const complainList = useSelector(state => state.complaindata.list);
  const pendingComplains = auth?.profile?.usertype === 'admin'
    ? (complainList || []).filter((c) => api.complainStatusOf(c) === 'pending').length
    : 0;

  const LogOut = () => {
    dispatch(signOff());
  };

  const [userMenuAnchor, setUserMenuAnchor] = useState(null);
  const userMenuOpen = Boolean(userMenuAnchor);
  const closeUserMenu = () => setUserMenuAnchor(null);

  const [role, setRole] = useState(null);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawer = () => {
    setMobileOpen(false);
  };

  const menuItems = [
    {name : t('home'), url:'/', icon: <HomeIcon/>, access: ['admin','fleetadmin','driver','customer']},
    {name : t('dashboard_text'), url:'/dashboard', icon: <DashboardIcon/>, access: ['admin','fleetadmin']},
    {name : t('booking_history'), url:'/bookings', icon: <ViewListIcon/>, access: ['admin','fleetadmin','driver','customer']},
    {name : t('addbookinglable'), url:'/addbookings', icon: <ContactPhoneIcon/>, access: calcEst && !showEst && !optionsRequired ? ['customer'] : ['admin','fleetadmin','customer']},
    {name : t('user'), url:'/users/0', icon: <EmojiPeopleIcon />, access: ['admin','fleetadmin']},
    {name : t('car_type'), url:'/cartypes', icon: <CarIcon/>, access: ['admin']},
    {name : 'Zonificación', url:'/zonificacion', icon: <MapIcon/>, access: ['admin']},
    {name : 'Tarifas mercado', url:'/tarifas-mercado', icon: <PriceChangeOutlinedIcon/>, access: ['admin']},
    {name : 'Red de Líderes', url:'/red-lideres', icon: <HubIcon/>, access: ['admin']},
    {name : 'Métricas', url:'/metricas', icon: <ShowChartIcon/>, access: ['admin']},
    {name : t('cars'), url:'/cars', icon: <CarIcon/>, access: ['admin','fleetadmin','driver']},
    {name : t('comission_withdraws_web'), url:'/comissionwithdraw', icon: <MoneyIcon />, access: ['admin']},
    {name : t('add_to_wallet'), url:'/addtowallet', icon: <AccountBalanceWalletIcon />, access: api.canAuthorizeWalletCredit(auth.profile) ? ['admin'] : []},
    {name : t('report'), url:'/allreports', icon: <AssessmentIcon />, access: ['admin','fleetadmin']},
    {name : t('promo'), url:'/promos', icon: <OfferIcon />, access: ['admin']},
    {name : t('push_notifications'), url:'/notifications', icon: <NotifyIcon />, access: ['admin']},
    {name : t('sos'), url:'/sos', icon: <SosIcon />, access: ['admin'], badge: pendingSos},
    {name : t('complain'), url:'/complain', icon: <AnnouncementOutlinedIcon/>, access: ['admin'], badge: pendingComplains},
    {name : t('my_wallet_tile'), url:'/userwallet', icon: <AccountBalanceWalletIcon />, access: ['driver','customer','fleetadmin']},
    {name : t('settings_title'), url:'/settings', icon: <SettingsOutlinedIcon />, access: ['admin']},
    {name : t('payment_settings'), url:'/paymentsettings', icon: <PhoneIphoneIcon />, access: ['admin']},
    {name : t('profile'), url:'/profile', icon: <AccountCircleIcon />, access: ['admin','fleetadmin','driver','customer']},
    {name : t('app_logs'), url:'/logs', icon: <BugReportOutlinedIcon />, access: ['admin']},
    {name : t('My_referrals'), url:'/myreferrals', icon: <PeopleAltIcon />, access: ['driver']},
    {name : t('Referral_bonus'), url:'/referral_bonus', icon: <LocalAtmIcon />, access: ['driver']},
    {name : t('logout'), url:'logout', icon: <ExitIcon />, access: ['admin','fleetadmin','driver','customer']}
  ];

  const isActive = (url) => {
    if (!url || url === 'logout') return false;
    if (url === '/') return location.pathname === '/';
    return location.pathname === url || location.pathname.startsWith(url + '/');
  };

  const displayName = auth?.profile
    ? `${auth.profile.firstName || ''} ${auth.profile.lastName || ''}`.trim() || auth.profile.email || 'Usuario'
    : 'Usuario';
  const initials = displayName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('') || 'U';
  const roleLabel = auth?.profile?.usertype
    ? (auth.profile.usertype === 'driver' ? 'Conductor' : auth.profile.usertype === 'customer' ? 'Usuario' : auth.profile.usertype)
    : '';

  const pageBanner = (() => {
    const path = location.pathname || '';
    if (path.startsWith('/cars/editcar')) {
      const isEdit = /^\/cars\/editcar\/[^/]+/.test(path);
      return {
        title: isEdit ? 'EDITAR VEHÍCULO' : 'NUEVO VEHÍCULO',
        titleAccent: 'VEHÍCULO',
        subtitle: isEdit
          ? 'Actualiza los datos del vehículo, su conductor y el tipo de servicio.'
          : 'Registra un vehículo y asígnalo a un conductor de Conecta2.',
        tagline: 'TU VEHÍCULO\nNUEVAS OPORTUNIDADES',
        icon: DirectionsCarOutlinedIcon,
      };
    }
    if (path.startsWith('/cars')) {
      return {
        title: t('cars_title') || 'VEHÍCULOS',
        subtitle: 'Administra tus vehículos registrados en Conecta2.',
        tagline: 'TU VEHÍCULO\nNUEVAS OPORTUNIDADES',
        icon: DirectionsCarOutlinedIcon,
      };
    }
    if (path.startsWith('/bookings') && !path.includes('/bookingdetails')) {
      return {
        title: 'MIS RESERVAS',
        titleAccent: 'RESERVAS',
        subtitle: 'Aquí puedes ver y gestionar tus reservas de viajes.',
        tagline: 'TU VIAJE\nNUESTRA PRIORIDAD',
        icon: ViewListOutlinedIcon,
      };
    }
    if (/^\/users\/\d+\/?$/.test(path)) {
      return {
        title: 'GESTIÓN DE USUARIOS',
        titleAccent: 'USUARIOS',
        subtitle: 'Administra usuarios, conductores, líderes, flotas y administradores de Conecta2.',
        tagline: 'JUNTOS LLEGAMOS\nMÁS LEJOS',
        icon: PeopleAltOutlinedIcon,
      };
    }
    if (path === '/cartypes' || path === '/cartypes/') {
      return {
        title: 'TIPOS DE VEHÍCULO',
        titleAccent: 'VEHÍCULO',
        subtitle: 'Configura tarifas, comisiones y visibilidad de cada servicio de Conecta2.',
        tagline: 'EN TODO\nCOLOMBIA',
        icon: LocalTaxiOutlinedIcon,
      };
    }
    if (path.startsWith('/cartypes/editcartype')) {
      const isEdit = /^\/cartypes\/editcartype\/[^/]+/.test(path);
      return {
        title: isEdit ? 'EDITAR TIPO DE VEHÍCULO' : 'NUEVO TIPO DE VEHÍCULO',
        titleAccent: 'VEHÍCULO',
        subtitle: isEdit
          ? 'Ajusta tarifas, comisiones y visibilidad de este servicio.'
          : 'Crea un nuevo servicio para que los usuarios puedan pedirlo.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: LocalTaxiOutlinedIcon,
      };
    }
    if (path === '/zonificacion' || path === '/zonificacion/') {
      return {
        title: 'ZONIFICACIÓN',
        subtitle: 'Ciudades habilitadas, cupos especiales y códigos de registro en Colombia.',
        tagline: 'EN TODO\nCOLOMBIA',
        icon: MapOutlinedIcon,
      };
    }
    if (path === '/red-lideres' || path === '/red-lideres/') {
      return {
        title: 'RED DE LÍDERES',
        titleAccent: 'LÍDERES',
        subtitle: 'Ciudades, cupos de los primeros 100, estructura de red y cumplimiento semanal.',
        tagline: 'JUNTOS LLEGAMOS\nMÁS LEJOS',
        icon: HubOutlinedIcon,
      };
    }
    if (path === '/metricas' || path === '/metricas/') {
      return {
        title: 'MÉTRICAS DE RED',
        titleAccent: 'RED',
        subtitle: 'Crecimiento de conductores y usuarios, niveles de red y cumplimiento semanal.',
        tagline: 'EN TODO\nCOLOMBIA',
        icon: InsightsOutlinedIcon,
      };
    }
    if (path === '/tarifas-mercado' || path === '/tarifas-mercado/') {
      return {
        title: 'TARIFAS MERCADO',
        titleAccent: 'MERCADO',
        subtitle: 'Benchmarks de competencia por ciudad, análisis DeepSeek y activación de tarifas (±15 %).',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: PriceChangeOutlinedIcon,
      };
    }
    if (path === '/withdraws' || path === '/withdraws/') {
      return {
        title: 'RETIROS DE BILLETERA',
        titleAccent: 'BILLETERA',
        subtitle: 'Solicitudes de retiro del saldo de los conductores de Conecta2.',
        tagline: 'TU VEHÍCULO\nNUEVAS OPORTUNIDADES',
        icon: PaymentsOutlinedIcon,
      };
    }
    if (path === '/comissionwithdraw' || path === '/comissionwithdraw/') {
      return {
        title: 'RETIROS DE COMISIÓN',
        titleAccent: 'COMISIÓN',
        subtitle: 'Solicitudes de retiro del bono de red de los días 15 y 30.',
        tagline: 'JUNTOS LLEGAMOS\nMÁS LEJOS',
        icon: PaymentsOutlinedIcon,
      };
    }
    if (path === '/allreports' || path === '/allreports/') {
      return {
        title: 'REPORTES',
        subtitle: auth?.profile?.usertype === 'admin'
          ? 'Ganancias de conductores, plataforma y flotas, y rendimiento de la red por niveles.'
          : 'Ganancias mensuales de los conductores de tu flota.',
        tagline: 'EN TODO\nCOLOMBIA',
        icon: AssessmentOutlinedIcon,
      };
    }
    if (path === '/addtowallet' || path === '/addtowallet/') {
      return {
        title: 'RECARGAR BILLETERA',
        titleAccent: 'BILLETERA',
        subtitle: 'Acredita saldo manualmente a la billetera de un conductor o usuario de Conecta2.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: AccountBalanceWalletOutlinedIcon,
      };
    }
    if (path === '/sos' || path === '/sos/') {
      return {
        title: 'ALERTAS SOS',
        titleAccent: 'SOS',
        subtitle: 'Solicitudes de ayuda de conductores y usuarios. Atiende primero las pendientes.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: SosIcon,
      };
    }
    if (path.startsWith('/notifications/addnotifications')) {
      return {
        title: 'NUEVA NOTIFICACIÓN',
        titleAccent: 'NOTIFICACIÓN',
        subtitle: 'Escribe el mensaje, elige a quién va dirigido y revisa cómo se verá en Android e iPhone antes de enviarlo.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: NotifyIcon,
      };
    }
    if (path === '/notifications' || path === '/notifications/') {
      return {
        title: 'NOTIFICACIONES PUSH',
        titleAccent: 'PUSH',
        subtitle: 'Avisos masivos a conductores y usuarios, con la entrega confirmada por plataforma (Android e iOS).',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: NotifyIcon,
      };
    }
    if (path === '/settings' || path === '/settings/') {
      return {
        title: 'CONFIGURACIÓN DE LA APP',
        titleAccent: 'APP',
        subtitle: 'Datos de la empresa, reglas de operación, idiomas, correo, SMS y motivos de cancelación.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: SettingsOutlinedIcon,
      };
    }
    if (path === '/logs' || path === '/logs/') {
      return {
        title: 'LOGS DE LA APP',
        titleAccent: 'LOGS',
        subtitle: 'Cierres y errores de la app de conductores y usuarios, con el dispositivo, la versión y la pantalla donde ocurrieron.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: BugReportOutlinedIcon,
      };
    }
    if (path === '/complain' || path === '/complain/') {
      return {
        title: 'QUEJAS Y SUGERENCIAS',
        titleAccent: 'QUEJAS',
        subtitle: 'Lo que conductores y usuarios reportan desde la app. Responde y el usuario recibirá un aviso.',
        tagline: 'TU DESTINO\nEN BUENAS MANOS',
        icon: AnnouncementOutlinedIcon,
      };
    }
    if (path.startsWith('/promos/editpromo')) {
      const isEdit = /^\/promos\/editpromo\/[^/]+/.test(path);
      return {
        title: isEdit ? 'EDITAR PROMOCIÓN' : 'NUEVA PROMOCIÓN',
        titleAccent: 'PROMOCIÓN',
        subtitle: isEdit
          ? 'Ajusta el descuento, la vigencia y los límites del código.'
          : 'Crea un código de descuento para los viajes de tus usuarios.',
        tagline: 'JUNTOS LLEGAMOS\nMÁS LEJOS',
        icon: LocalOfferOutlinedIcon,
      };
    }
    if (path === '/promos' || path === '/promos/') {
      return {
        title: 'PROMOCIONES',
        titleAccent: 'PROMOCIONES',
        subtitle: 'Códigos de descuento para los viajes y campañas de saldo de bienvenida para conductores nuevos.',
        tagline: 'JUNTOS LLEGAMOS\nMÁS LEJOS',
        icon: LocalOfferOutlinedIcon,
      };
    }
    if (path.startsWith('/addbookings')) {
      return {
        title: 'NUEVA RESERVA',
        titleAccent: 'RESERVA',
        subtitle: 'Elige origen, destino y vehículo para solicitar tu viaje.',
        tagline: 'PIDE YA\nEN CONECTA2',
        icon: AddLocationAltOutlinedIcon,
      };
    }
    // Mock BILLETERA usa título propio, sin franja oscura
    if (path.startsWith('/userwallet')) {
      return null;
    }
    // Mock PERFIL usa título propio, sin franja oscura
    if (path.startsWith('/profile')) {
      return null;
    }
    // Mock Mis Referidos usa banner propio
    if (path.startsWith('/myreferrals')) {
      return null;
    }
    // Mock Bonus usa título/layout propio
    if (path.startsWith('/referral_bonus')) {
      return null;
    }
    if (path === '/' || path.startsWith('/dashboard')) {
      return {
        title: path.startsWith('/dashboard') ? (t('dashboard_text') || 'DASHBOARD') : (t('home') || 'INICIO'),
        subtitle: 'Bienvenido al panel de Conecta2.',
        tagline: 'EN TODO\nCOLOMBIA',
        icon: path.startsWith('/dashboard') ? DashboardOutlinedIcon : HomeOutlinedIcon,
      };
    }
    return null;
  })();

  const drawer = (
    <Box
      sx={{
        backgroundColor: SIDEBAR_BG,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 2,
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
          <img
            style={{ width: 48, height: 48, objectFit: 'contain' }}
            src={logoImg}
            alt="Conecta2"
          />
          <Typography
            sx={{
              color: '#FBFAFE',
              fontFamily: "'Outfit', 'Poppins', sans-serif",
              fontWeight: 800,
              fontSize: '1.15rem',
              letterSpacing: '0.02em',
            }}
          >
            Conecta2
          </Typography>
        </Box>
        <Tooltip title="Ocultar menú lateral">
          <IconButton
            onClick={toggleDesktopSidebar}
            sx={{
              color: '#D7CFEB',
              display: { xs: 'none', sm: 'inline-flex' },
              backgroundColor: 'rgba(255,255,255,0.06)',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.15)', color: '#FFFFFF' },
              borderRadius: '8px',
              p: 0.5,
            }}
          >
            {isRTL === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', px: 1, pb: 1 }}>
        {role ? (
          <List disablePadding dense={false}>
            {menuItems.map((item, index) => (
              item.access.includes(role) ? (
                <ListItem
                  key={`nav-${index}`}
                  disableGutters
                  disablePadding
                  sx={{ mb: 0.4 }}
                  onClick={handleDrawer}
                >
                  <ListItemButton
                    component={item.url === 'logout' ? 'button' : Link}
                    to={item.url === 'logout' ? undefined : item.url}
                    onClick={item.url === 'logout' ? LogOut : undefined}
                    sx={{
                      borderRadius: '12px',
                      mx: 0.5,
                      py: 1.1,
                      px: 1.5,
                      backgroundColor: isActive(item.url) ? ACTIVE_BG : 'transparent',
                      boxShadow: isActive(item.url) ? '0 0 18px rgba(100,17,237,0.45)' : 'none',
                      '&:hover': {
                        backgroundColor: isActive(item.url) ? ACTIVE_BG : 'rgba(100,17,237,0.22)',
                      },
                    }}
                  >
                    <ListItemIcon sx={{ color: '#FBFAFE', minWidth: 40 }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          sx={{
                            color: '#FBFAFE',
                            textAlign: isRTL === 'rtl' ? 'right' : 'left',
                            fontFamily: "'Outfit', 'Poppins', sans-serif",
                            fontSize: '13.5px',
                            fontWeight: isActive(item.url) ? 700 : 500,
                          }}
                        >
                          {item.name}
                        </Typography>
                      }
                    />
                    {item.badge > 0 ? (
                      <Box
                        component="span"
                        sx={{
                          minWidth: 22,
                          height: 22,
                          px: 0.75,
                          borderRadius: '11px',
                          backgroundColor: '#DC2626',
                          color: '#FFFFFF',
                          fontFamily: "'Outfit', 'Poppins', sans-serif",
                          fontSize: '0.72rem',
                          fontWeight: 800,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 0 0 3px rgba(220,38,38,0.25)',
                        }}
                      >
                        {item.badge > 99 ? '99+' : item.badge}
                      </Box>
                    ) : null}
                  </ListItemButton>
                </ListItem>
              ) : null
            ))}
          </List>
        ) : null}
      </Box>

      {role === 'driver' || role === 'customer' ? (
      <Box
        sx={{
          flexShrink: 0,
          mx: 1.5,
          mb: 2,
          mt: 1,
          borderRadius: '16px',
          overflow: 'hidden',
          position: 'relative',
          height: 200,
          border: '1px solid rgba(118,40,255,0.45)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.28)',
          backgroundColor: '#2A1850',
        }}
      >
        <Box
          component="img"
          src={sidebarPromoImg}
          alt=""
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            /* Car sits bottom-right in driver_vertical.jpg */
            objectPosition: '85% 78%',
            display: 'block',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: '42%',
            background:
              'linear-gradient(180deg, rgba(26,15,59,0) 0%, rgba(26,15,59,0.55) 55%, rgba(26,15,59,0.88) 100%)',
            pointerEvents: 'none',
          }}
        />
        <Typography
          sx={{
            position: 'absolute',
            left: 12,
            right: 12,
            bottom: 12,
            zIndex: 1,
            fontFamily: "'Outfit', 'Poppins', sans-serif",
            fontWeight: 700,
            fontSize: '13px',
            color: '#FBFAFE',
            lineHeight: 1.3,
            textShadow: '0 2px 10px rgba(0,0,0,0.75)',
          }}
        >
          Juntos llegamos más lejos
        </Typography>
      </Box>
      ) : null}
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', direction: isRTL === 'rtl' ? 'rtl' : 'ltr', backgroundColor: '#F4F2FE', minHeight: '100vh' }}>
      <CssBaseline />
      <style>
        {`
          ::-webkit-scrollbar { width: 8px; }
          ::-webkit-scrollbar-thumb { background-color: ${SECONDORY_COLOR}; border-radius: 6px; }
          ::-webkit-scrollbar-thumb:hover { background-color: ${MAIN_COLOR}; }
          ::-webkit-scrollbar-track { background-color: ${colors.WHITE}; }
        `}
      </style>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: desktopOpen ? `calc(100% - ${drawerWidth}px)` : '100%' },
          ml: { sm: desktopOpen ? (isRTL === 'rtl' ? 0 : `${drawerWidth}px`) : 0 },
          mr: { sm: desktopOpen ? (isRTL === 'rtl' ? `${drawerWidth}px` : 0) : 0 },
          transition: 'width 0.22s cubic-bezier(0.4, 0, 0.2, 1), margin 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
          backgroundColor: SIDEBAR_BG,
          borderBottom: '1px solid rgba(118,40,255,0.25)',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', minHeight: { xs: 56, sm: 64 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: 'none' }, color: '#FBFAFE' }}
            >
              <MenuIcon />
            </IconButton>

            <Tooltip title={desktopOpen ? "Ocultar menú lateral" : "Mostrar menú lateral"}>
              <IconButton
                color="inherit"
                aria-label="toggle desktop sidebar"
                edge="start"
                onClick={toggleDesktopSidebar}
                sx={{
                  display: { xs: 'none', sm: 'inline-flex' },
                  color: '#FBFAFE',
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  borderRadius: '10px',
                  p: 0.8,
                  mr: 0.5,
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.18)' },
                  transition: 'all 0.2s ease',
                }}
              >
                {desktopOpen ? (isRTL === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />) : (isRTL === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />)}
              </IconButton>
            </Tooltip>

            <Typography
              variant="h6"
              noWrap
              sx={{
                color: '#FBFAFE',
                fontFamily: "'Outfit', 'Poppins', sans-serif",
                fontWeight: 700,
                fontSize: '1.05rem',
              }}
            >
              {settings?.appName || 'Conecta2'}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <IconButton
              sx={{ color: '#FBFAFE' }}
              aria-label={pendingSos > 0 ? `${pendingSos} alertas SOS pendientes` : 'notifications'}
              title={pendingSos > 0 ? `${pendingSos} alertas SOS pendientes` : undefined}
              component={pendingSos > 0 ? Link : 'button'}
              to={pendingSos > 0 ? '/sos' : undefined}
            >
              <Badge badgeContent={pendingSos} color="error" invisible={pendingSos === 0} max={99}>
                <NotificationsNoneIcon />
              </Badge>
            </IconButton>
            <ButtonBase
              onClick={(e) => setUserMenuAnchor(e.currentTarget)}
              aria-haspopup="true"
              aria-expanded={userMenuOpen ? 'true' : undefined}
              aria-controls={userMenuOpen ? 'c2-user-menu' : undefined}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                borderRadius: '14px',
                px: 1,
                py: 0.5,
                transition: 'background-color .15s',
                backgroundColor: userMenuOpen ? 'rgba(255,255,255,0.10)' : 'transparent',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
              }}
            >
              <Avatar
                src={auth?.profile?.profile_image || undefined}
                sx={{
                  width: 36,
                  height: 36,
                  bgcolor: ACTIVE_BG,
                  fontSize: 13,
                  fontWeight: 700,
                  fontFamily: "'Outfit', 'Poppins', sans-serif",
                }}
              >
                {initials}
              </Avatar>
              <Box sx={{ display: { xs: 'none', md: 'block' }, lineHeight: 1.2 }}>
                <Typography sx={{ color: '#FBFAFE', fontSize: 13, fontWeight: 700, fontFamily: "'Outfit', 'Poppins', sans-serif" }}>
                  {displayName}
                </Typography>
                <Typography sx={{ color: '#D7CFEB', fontSize: 11, fontFamily: "'Outfit', 'Poppins', sans-serif" }}>
                  {roleLabel}
                </Typography>
              </Box>
              <KeyboardArrowDownIcon
                sx={{
                  color: '#D7CFEB',
                  display: { xs: 'none', md: 'block' },
                  transition: 'transform .2s',
                  transform: userMenuOpen ? 'rotate(180deg)' : 'none',
                }}
              />
            </ButtonBase>
            <Menu
              id="c2-user-menu"
              anchorEl={userMenuAnchor}
              open={userMenuOpen}
              onClose={closeUserMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              slotProps={{
                paper: {
                  sx: {
                    mt: 1,
                    minWidth: 220,
                    borderRadius: '14px',
                    border: '1px solid #D7CFEB',
                    boxShadow: '0 12px 28px rgba(26,15,59,0.18)',
                    fontFamily: "'Outfit', 'Poppins', sans-serif",
                  },
                },
              }}
            >
              <Box sx={{ px: 2, py: 1.25 }}>
                <Typography sx={{ fontFamily: "'Outfit', 'Poppins', sans-serif", fontWeight: 700, fontSize: 14, color: SIDEBAR_BG }}>
                  {displayName}
                </Typography>
                <Typography sx={{ fontFamily: "'Outfit', 'Poppins', sans-serif", fontSize: 12, color: '#766293', wordBreak: 'break-all' }}>
                  {auth?.profile?.email || roleLabel}
                </Typography>
              </Box>
              <Divider sx={{ borderColor: '#EBE7FB' }} />
              <MenuItem
                component={Link}
                to="/profile"
                onClick={closeUserMenu}
                sx={{ fontFamily: "'Outfit', 'Poppins', sans-serif", fontSize: 14, color: SIDEBAR_BG, py: 1.1, mt: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 34 }}>
                  <AccountCircleIcon fontSize="small" sx={{ color: ACTIVE_BG }} />
                </ListItemIcon>
                Mi perfil
              </MenuItem>
              <MenuItem
                onClick={() => {
                  closeUserMenu();
                  LogOut();
                }}
                sx={{ fontFamily: "'Outfit', 'Poppins', sans-serif", fontSize: 14, fontWeight: 700, color: '#B91C1C', py: 1.1, '&:hover': { backgroundColor: '#FEF2F2' } }}
              >
                <ListItemIcon sx={{ minWidth: 34 }}>
                  <ExitIcon fontSize="small" sx={{ color: '#B91C1C' }} />
                </ListItemIcon>
                Cerrar sesión
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {!desktopOpen && (
        <Tooltip title="Mostrar menú lateral" placement="right">
          <Box
            onClick={toggleDesktopSidebar}
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              justifyContent: 'center',
              position: 'fixed',
              top: '50%',
              left: isRTL === 'rtl' ? 'auto' : 0,
              right: isRTL === 'rtl' ? 0 : 'auto',
              transform: 'translateY(-50%)',
              zIndex: 1250,
              backgroundColor: SIDEBAR_BG,
              color: '#FBFAFE',
              border: '1.5px solid #6411ED',
              borderLeft: isRTL === 'rtl' ? '1.5px solid #6411ED' : 'none',
              borderRight: isRTL === 'rtl' ? 'none' : '1.5px solid #6411ED',
              borderTopRightRadius: isRTL === 'rtl' ? 0 : '12px',
              borderBottomRightRadius: isRTL === 'rtl' ? 0 : '12px',
              borderTopLeftRadius: isRTL === 'rtl' ? '12px' : 0,
              borderBottomLeftRadius: isRTL === 'rtl' ? '12px' : 0,
              px: 0.6,
              py: 1.6,
              cursor: 'pointer',
              boxShadow: '0 4px 18px rgba(26,15,59,0.35)',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: ACTIVE_BG,
                transform: `translateY(-50%) ${isRTL === 'rtl' ? 'translateX(-2px)' : 'translateX(2px)'}`,
              },
            }}
          >
            {isRTL === 'rtl' ? <ChevronLeftIcon sx={{ fontSize: 20 }} /> : <ChevronRightIcon sx={{ fontSize: 20 }} />}
          </Box>
        </Tooltip>
      )}

      <Box
        component="nav"
        sx={{
          width: { sm: desktopOpen ? drawerWidth : 0 },
          flexShrink: { sm: 0 },
          transition: 'width 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: SIDEBAR_BG,
              border: 'none',
              direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: SIDEBAR_BG,
              border: 'none',
              direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
              transform: desktopOpen ? 'none' : `translateX(${isRTL === 'rtl' ? '100%' : '-100%'})`,
              visibility: desktopOpen ? 'visible' : 'hidden',
              transition: 'transform 0.22s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.22s ease',
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1.5, sm: 2 },
          width: { sm: desktopOpen ? `calc(100% - ${drawerWidth}px)` : '100%' },
          transition: 'width 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
          backgroundColor: '#F4F2FE',
          minHeight: '100vh',
        }}
      >
        <Toolbar />
        {pageBanner ? (
          <DashboardPageBanner
            title={pageBanner.title}
            titleAccent={pageBanner.titleAccent}
            subtitle={pageBanner.subtitle}
            tagline={pageBanner.tagline}
            icon={pageBanner.icon}
          />
        ) : null}
        {props.children}
      </Box>
    </Box>
  );
}
